import sliceCreator from '../../index.jsx';
import {CREATE_POST_ACTIVITY} from '../../../constants/index.jsx';
const _createPostActivityAction = sliceCreator('CREATE_POST_ACTIVITY', CREATE_POST_ACTIVITY, 'post');

const { asyncAction: createPostActivityAction, reducer, clearData: clearCreatePostActivityAction } = _createPostActivityAction;

export default reducer;

export {
    createPostActivityAction,
    clearCreatePostActivityAction
}